__turbopack_context__.v({
  "desktopImage": "Hero-module-scss-module__KGd41G__desktopImage",
  "heroContainer": "Hero-module-scss-module__KGd41G__heroContainer",
  "heroImageContainer": "Hero-module-scss-module__KGd41G__heroImageContainer",
  "mobileImage": "Hero-module-scss-module__KGd41G__mobileImage",
  "videoWrapper": "Hero-module-scss-module__KGd41G__videoWrapper",
});
